<div class="h-h">
  <div>
    <mn-svg
      data-ui-sound
      mnClickArea
      class="c-p cu-p"
      name="arrow"
      mnAnalyticsClick="back_sidebar_limits"
      (click)="close($event, true)" />
    <b class="t-h u-c">{{ "limits.title" | mnTranslate }}</b>
  </div>
  <mn-button aEvent="limits_close" (clicked)="close($event, false)">
    <mn-svg name="close" />
  </mn-button>
</div>
<div class="f-w g-12 f-c o-y-a">
  <span class="c-t t-s">{{ "limits.note" | mnTranslate }}</span>

  @for (limit of ls(); track limit.text) {
    <div class="item t-s p-16 c-p">
      <strong class="u-c">{{ "limits." + limit.text | mnTranslate }}</strong>
      <strong>{{ prefix + "&nbsp;" + limit.value }}</strong>
    </div>
  }
</div>
